import { NgClass } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CustomThemeIds } from '@safarilaw-webapp/feature/rms/data-access';
import { MaintenanceInfo } from '@safarilaw-webapp/shared/app-bootstrap/data-access';

@Component({
  selector: 'sl-rms-maintenance-splash',
  templateUrl: './maintenance-splash.html',
  styleUrls: ['./maintenance-splash.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass]
})
export class MaintenanceSplashComponent {
  @Input()
  maintenanceInfo: MaintenanceInfo = undefined;

  get title() {
    return this.maintenanceInfo?.splash?.title || 'WEBSITE MAINTENANCE IN PROGRESS';
  }
  get details() {
    return this.maintenanceInfo?.splash?.details || 'ServePort is undergoing scheduled maintenance. Please check back later.';
  }

  get customThemeId(): string {
    return window['Safari']?.customThemeId as string;
  }

  get customThemeCss(): string {
    if (this.customThemeId == CustomThemeIds.walmart) {
      return CustomThemeIds.walmart;
    }
    return '';
  }

  get customThemeBannerCss(): string[] {
    if (this.customThemeId == CustomThemeIds.walmart) {
      return ['py-4', 'alert-light'];
    }
    return [];
  }
}
